import { configureStore } from "@reduxjs/toolkit";
import auth from "./slices/auth";
import search from "./slices/search";
import pins from "./slices/mapPins";
import trips from "./slices/trips";
import currency from "./slices/currency";
export const store = configureStore({
  reducer: {
    auth,
    search,
    pins,
    trips,
    currency,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable non-serializable value check
    }),
});
